export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11540.7169c278.jpg";